import React from 'react';
import PropTypes from 'prop-types';

import ProfilePhoto from './profile_photo';

const LabeledProfilePhoto = ({ initials, label, photoUrl, value }) => {
  return (
    <React.Fragment>
      <span className="text-muted text-uppercase right-buffer-md">{label ? `${label}:` : ''}</span>
      <ProfilePhoto initials={initials} photoUrl={photoUrl} value={value}/>
    </React.Fragment>
  );
};

LabeledProfilePhoto.propTypes = {
  initials: PropTypes.string,
  label: PropTypes.string.isRequired,
  photoUrl: PropTypes.string,
  value: PropTypes.string.isRequired
};

export default LabeledProfilePhoto;
